import { CircularProgress } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { GlobalButton } from '..';
import { GlobalButtonVariant } from '../buttons/GlobalButton';

export interface SubmitButtonProps {
  action: () => void;
  icon?: React.ReactNode;
  label: string;
  isLoading: boolean;
  disabled?: boolean;
  variant?: GlobalButtonVariant;
}

const FormSubmitButton = ({
  action,
  icon,
  label,
  isLoading,
  disabled,
  variant = GlobalButtonVariant.primaryButton,
}: SubmitButtonProps) => {
  return (
    <GlobalButton
      variant={variant}
      action={action}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <CircularProgress size={20} sx={{ color: 'var(--white-color)' }} />
      ) : (
        icon || <AddIcon />
      )}
      {label}
    </GlobalButton>
  );
};

export default FormSubmitButton;
